import { render, staticRenderFns } from "./GraficoDonut.vue?vue&type=template&id=18760bf1&"
import script from "./GraficoDonut.vue?vue&type=script&lang=js&"
export * from "./GraficoDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports